import { template } from "@ember/template-compiler";
import { LinkTo } from '@ember/routing';
const hash = (k1, v1)=>{
    return {
        [k1]: v1
    };
};
export default template(`
  <div class='widget-sidebar'>
    <div class='section-title-wrap blue'>
      <h2 class='section-title medium'>Tags</h2>
      <div class='section-title-separator'></div>
    </div>
    <div class='tag-list'>
      {{#each @tags as |tag|}}
        <LinkTo @route='search' @query={{hash 'tag' tag}} class='tag-item'>{{tag}}</LinkTo>
      {{/each}}
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
